<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="padding-b pb-md-12"
      maxwidth-container="610px"
    >
      <TituloPagina
        :titulo="titulo"
        class="mt-5 mt-md-11"
      />

      <v-form
        ref="form"
        class="mt-7 mt-md-9"
      >
        <v-col class="my-0 pa-0">
          <v-text-field
            ref="senha_atual"
            v-model="senhaAtual"
            background-color="white"
            label="Senha atual"
            filled
            required
            data-cy="input_senha_atual"
            :autofocus="autofocus"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            :type="show1 ? 'text' : 'password'"
            :rules="[
              () => !senhaAtualErro || 'Senha atual incorreta',
              () => !!senhaAtual || 'Este campo é obrigátorio',
            ]"
            @click:append="show1 = !show1"
            @keydown="senhaAtualErro = false"
          />

          <v-text-field
            v-model="senha"
            background-color="white"
            label="Nova senha"
            filled
            data-cy="input_nova_senha"
            :append-icon="show2 ? 'visibility' : 'visibility_off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            @focus="senhaNaoValida = true"
          />

          <transition name="slide-fade">
            <div v-show="mostrarRegras" class="caption mt-n4" data-cy="forca_da_senha">
              <p class="grey--text text--darken-2 caption mb-0">
                Por motivos de segurança, sua senha precisa obedecer os seguintes critérios:
              </p>
              <ul
                class="mb-5"
                style="list-style: none; padding: 0;"
              >
                <li
                  v-for="(rule, ruleKey) in senhaRegras"
                  :key="ruleKey"
                  :class="regraEstilo[ruleKey].color + '--text'"
                >
                  <v-icon
                    :color="regraEstilo[ruleKey].color"
                    x-small
                    class="mr-2"
                    v-text="'fas fa-' + regraEstilo[ruleKey].icon"
                  />
                  <span v-html="rule" />
                </li>
              </ul>
            </div>
          </transition>

          <v-text-field
            v-model="senhaConfirmacao"
            label="Confirmar a nova senha"
            filled
            data-cy="input_repita_senha"
            background-color="white"
            :append-icon="show3 ? 'visibility' : 'visibility_off'"
            :type="show3 ? 'text' : 'password'"
            :error-messages="senhaErroRepitir"
            @click:append="show3 = !show3"
          />
        </v-col>
      </v-form>

      <div
        :class="$vuetify.breakpoint.mdAndUp
          ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile'"
        class="grey lighten-3 botoes-rodape pa-3 px-md-0 mt-md-2"
      >
        <v-btn
          :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
          color="primary"
          outlined
          exact
          data-cy="btn_voltar"
          to="/meu-perfil"
        >
          Voltar
        </v-btn>

        <v-btn
          :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
          :disabled="disabled"
          :loading="loading"
          color="primary"
          data-cy="btn_salvar"
          @click="mudarSenha()"
        >
          Salvar
        </v-btn>
      </div>

      <SnackBar
        :mensage="snackBar.message"
        :snackbar="snackBar.show"
        :button="true"
        :color="snackBar.color"
        :timeout="snackBar.timeout"
        @changeSnackBar="respostaSnackbar($event)"
      />
    </InternaMain>
  </Wrapper>
</template>

<script>
import { sameAs } from 'vuelidate/lib/validators';
import { passwordStrengthRules } from '@/utils';

import ApiMeuPerfil from '@/api/meuPerfil';
import InternaMain from '@/components/InternaMain.vue';
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'AlterarSenha',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    SnackBar,
  },

  data() {
    return {
      titulo: 'Alterar minha senha',
      show1: false,
      show2: false,
      show3: false,
      senha: '',
      senhaAtual: '',
      senhaAtualErro: false,
      senhaConfirmacao: '',
      senhaNaoValida: false,
      senhaMensagens: ['A nova senha é diferente da confirmação.'],
      senhaRegrasResultado: {},
      senhaErroRepitir: '',
      senhaRegras: {
        minLength: 'Deve conter no mínimo <strong>8 caracteres</strong>.',
        ucCharacter: 'Deve conter pelo menos <strong>uma letra maiúscula</strong>.',
        lcCharacter: 'Deve conter pelo menos <strong>uma letra minúscula</strong>.',
        number: 'Deve conter pelo menos <strong>um número</strong>.',
        spCharacter: 'Deve conter pelo menos <strong>um símbolo</strong> (ex: #!.?@)',
        different: 'Deve ser diferente da <strong>senha atual</strong>',
      },
      autofocus: false,
      disabled: true,
      loading: false,
      snackBar: {
        message: 'Senha alterada com sucesso',
        color: 'success',
        timeout: 5000,
        show: false,
      },
    };
  },

  validations() {
    return {
      senhaConfirmacao: {
        sameAsPassword: sameAs('senha'),
      },
    };
  },

  computed: {
    mostrarRegras() {
      return this.senhaNaoValida && !this.senhaRegrasResultado.valid;
    },

    regraEstilo() {
      return Object.keys(this.senhaRegras).reduce((regraAcumulator, regrasKey) => {
        const estilo = regraAcumulator;
        estilo[regrasKey] = {
          color: this.senhaRegrasResultado[regrasKey] ? 'success' : 'error',
          icon: this.senhaRegrasResultado[regrasKey] ? 'check' : 'times',
        };
        return estilo;
      }, {});
    },
  },

  watch: {
    senhaAtual() {
      if (this.senha && this.senhaAtual) {
        this.senhaRegrasResultado = passwordStrengthRules(this.senha, this.senhaAtual);
      }
      this.formValidado();
    },

    senha(password) {
      if (password && this.senhaAtual) {
        this.senhaRegrasResultado = passwordStrengthRules(password, this.senhaAtual);
      }
      this.formValidado();
      this.senhaConfirmacaoValida();
    },

    senhaConfirmacao() {
      this.$v.senhaConfirmacao.$touch();
      this.senhaConfirmacaoValida();
      this.formValidado();
    },
  },

  methods: {
    senhaConfirmacaoValida() {
      const mensagem = !this.$v.senhaConfirmacao.sameAsPassword ? this.senhaMensagens[0] : '';
      if (this.senhaConfirmacao && this.senhaConfirmacao.length > 0) {
        this.senhaErroRepitir = mensagem;
      }
    },

    formValidado() {
      if (this.$v.senhaConfirmacao.sameAsPassword
        && this.senhaAtual
        && this.senhaRegrasResultado.valid
      ) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },

    mudarSenha() {
      const formData = new FormData();
      formData.set('currentPassword', this.senhaAtual);
      formData.set('password', this.senha);
      formData.set('confirmPassword', this.senhaConfirmacao);
      this.loading = true;

      ApiMeuPerfil.resetPassword(formData)
        .then(() => {
          this.snackBar.show = true;
          this.$refs.form.reset();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.senhaAtualErro = true;
            this.autofocus = true;
          } else {
            this.snackBar.message = 'Tente novamente mais tarde.';
            this.snackBar.color = 'error';
            this.snackBar.show = true;
          }
        })
        .finally(() => {
          this.senhaAtual = '';
          this.loading = false;
        });
    },

    respostaSnackbar(v) {
      this.snackBar.show = v.visible;

      if (this.snackBar.color === 'success') {
        this.$router.push('/meu-perfil');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
